export default __webpack_public_path__ + "static/image 65-b6891d7368326bc2fbd253b3701076ad.png";